var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-reports-wrapper"},[_c('vue-headful',{attrs:{"title":"Reports"}}),_c('h3',[_vm._v("Reports")]),_c('p',[_vm._v("Some kind of reports go here")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }